export interface Address {
  line1?: string;
  line2?: string;
  locality?: string;
  city?: keyof typeof CITY_CODE_MAP | string;
  state?: keyof typeof STATE_CODE_MAP | string;
  country?: keyof typeof COUNTRY_CODE_MAP | string;
  zip?: string | number;
}

export const COUNTRY_CODE_MAP = {
  IN: "India",
} as const;

export const STATE_CODE_MAP = {
  HR: "Haryana",
  KA: "Karnataka",
  RJ: "Rajasthan",
  UP: "Uttar Pardesh",
} as const;

export const CITY_CODE_MAP = {
  AWR: "Alwar",
  BLR: "Bengaluru",
  BNW: "Bhiwani",
  BPM: "Baghpat",
  BSC: "Bulandshahr",
  BTE: "Bharatput",
  DLI: "Delhi",
  FDN: "Faridabad",
  GGN: "Gurgaon",
  GZB: "Ghaziabad",
  HPU: "Hapur",
  JHJ: "Jhajjar",
  JIND: "Jind",
  KUN: "Karnal",
  MHRG: "Mahendragarh",
  MOZ: "Muzaffanagar",
  MTC: "Meerut",
  PNP: "Panipat",
  PWL: "Palwal",
  RE: "Rewari",
  SMQL: "Shamli",
  SNP: "Sonipat",
} as const;

export function isValidArray<T>(
  arr: T[] | null | undefined
): arr is T[] {
  return Array.isArray(arr) && arr.length > 0;
}

export function uniqArray<T>(
  arr: T[] | null | undefined
): T[] {
  if (!isValidArray(arr)) return [];
  return Array.from(new Set(arr));
}

export const formatAddress = (address?: Address): string => {
  if (!address) return "";

  const parts = [
    address.line1,
    address.line2,
    address.locality,
    CITY_CODE_MAP[address.city as keyof typeof CITY_CODE_MAP] ??
      address.city,
    STATE_CODE_MAP[address.state as keyof typeof STATE_CODE_MAP] ??
      address.state,
    COUNTRY_CODE_MAP[address.country as keyof typeof COUNTRY_CODE_MAP] ??
      address.country,
    address.zip?.toString(),
  ]
    .filter(Boolean)
    .map((s) => String(s).trim());

  return uniqArray(parts).join(", ");
};


export const formatDate = (isoDate: string): string => {
  if (!isoDate) return "-";

  return new Date(isoDate).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};